export default "__VITE_ASSET__DUAbs3xq__"